import React, { Component, Fragment } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as ReportsActions } from 'store/ducks/reports';

import { Page, Breadcrumbs, Panel, Loading } from 'components';
import { Filters } from './components';

class VoucherExpense extends Component {
  state = {
    filter: {
      start_at: null,
      end_at: null,
      date_formatted: '',
    },
    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Relatórios', to: '/reports' },
      { name: 'Relatório de Despesas com Vouchers', to: '' },
    ],
  };

  // componentDidMount() {
  //   const { getReportVouchersExpensesRequest } = this.props;

  //   getReportVouchersExpensesRequest(this.state.filter);
  // }

  // componentDidUpdate(oldProps, oldState) {
  //   const { filter } = this.state;

  //   if (oldState.filter.start_at !== filter.start_at || oldState.filter.end_at !== filter.end_at) {
  //     const date_formatted = filter.start_at
  //       ? `${filter.start_at !== null ? moment(filter.start_at).format('DD/MM/YYYY') : ''} ${
  //           filter.end_at !== null ? '-' : ''
  //         } ${filter.end_at !== null ? moment(filter.end_at).format('DD/MM/YYYY') : ''}`
  //       : '';

  //     this.setState({ filter: { ...filter, date_formatted } });
  //   }
  // }

  handleSubmit = () => {
    const { getReportVouchersExpensesRequest } = this.props;

    getReportVouchersExpensesRequest(this.state.filter);
  };

  handleChangeDate = async (name, value) => {
    const { filter } = this.state;

    await this.setState({ filter: { ...filter, [name]: value } });
  };

  handleCleanFilter = async e => {
    e.preventDefault();

    const { getReportVouchersExpensesRequest } = this.props;

    await this.setState({
      filter: {
        start_at: null,
        end_at: null,
        date_formatted: '',
      },
    });

    getReportVouchersExpensesRequest(null);
  };

  handleExport = async (name, value) => {
    const { filter } = this.state;
    const { exportReportVouchersExpensesRequest } = this.props;

    await this.setState({ filter: { ...filter, [name]: value } });
    exportReportVouchersExpensesRequest(this.state.filter);
  };

  render() {
    const { breadcrumbs, filter } = this.state;
    const { reports } = this.props;

    return (
      <Page className="page-reports">
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <header className="page-reports-header">
          <Page.Title>Relatório de Despesas Com Vouchers</Page.Title>

          <Filters
            data={filter}
            onChange={this.handleChangeDate}
            onClean={this.handleCleanFilter}
            onSubmit={this.handleSubmit}
          />

        </header>

        <Panel className="panel-list">
          {reports.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {reports.loading && <Loading type="table" size="x-large" />}

              {filter.date_formatted !== "" && (
                <Panel.Title>
                  Período: <span>{filter.date_formatted}</span>
                </Panel.Title>
              )}

              <h5>Relatório de Despesas Com Vouchers</h5>

              <table className="contact-table table table-curved">
                <thead>
                  <tr>
                    <th className="subTitle-report">Loja</th>
                    <th className="subTitle-report">Expirado(R$)</th>
                    <th className="subTitle-report">Ativado(R$)</th>
                    <th className="subTitle-report">Utilizado(R$)</th>
                  </tr>
                </thead>

                <tbody>
                  {!reports.data.length && (
                    <tr>
                      <td colSpan="4" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}
                  {reports.data.map(report => (
                    <tr key={report.id}>
                      <td>{report.name}</td>
                      <td>
                        {parseFloat(report.expired).toLocaleString("pt-BR", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}
                      </td>
                      <td>
                        {parseFloat(report.activated).toLocaleString("pt-BR", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}
                      </td>
                      <td>
                        {parseFloat(report.used).toLocaleString("pt-BR", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th>Total</th>
                    <th>
                      {reports.total.expired.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL"
                      })}
                    </th>
                    <th>
                      {reports.total.actives.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL"
                      })}
                    </th>
                    <th>
                      {reports.total.used.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL"
                      })}
                    </th>
                  </tr>
                </tfoot>
              </table>

              <button className="button-submit" onClick={this.handleExport}>
                Exportar Planilha
              </button>
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapstate = state => ({
  reports: state.reports.voucherExpense,
});

const mapActions = dispatch => bindActionCreators(ReportsActions, dispatch);

export default connect(
  mapstate,
  mapActions,
)(VoucherExpense);
